import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    dark: {
      100: '#01040D',
      95: '#0E1119',
      90: '#1A1D25',
      80: '#34363D',
      40: '#999B9E',
      10: '#E6E6E7',
    },
    red: {
      100: '#EC1656',
      80: '#F04578',
    },
    blue: {
      100: '#26D8F0',
    },
  },
  sizes: {
    hpContainerWidth: '980px',
  },
  fontSizes: {
    10: '10px',
    xs: '12px',
    sm: '14px',
    md: '18px',
    lg: '24px',
    xl: '28px',
    '4xl': '40px',
    '5xl': '72px',
  },
  space: {
    sectionYPadding: '114px',
  },
  fonts: {
    bold: 'PlusJakartaSansBold, sans-serif',
    regular: 'PlusJakartaSansRegular, sans-serif',
  },
  fontWeights: {
    regular: 400,
    bold: 700,
  },
  borderRadius: {},
});

export default theme;
